
import { mapGetters, mapMutations } from 'vuex'
export default {
  computed: {
    ...mapGetters('unidade', ['unidadeInformation']),
    dialog() {
      // Verifica se unidadeInformation.dialog é null
      if (this.unidadeInformation && this.unidadeInformation.dialog === null) {
        return false
      }
      // Caso contrário, retorna o valor de status
      return this.unidadeInformation && this.unidadeInformation.dialog
        ? this.unidadeInformation.dialog.status
        : false
    },
  },
  methods: {
    ...mapMutations('unidade', ['CLOSE_DIALOG_STATUS']),
  },
}
